<template>
  <div>
    <section-title
      class="mt-4"
      icon="fa fa-clipboard-list-check"
      :title="title"
      title-class="font-14"
    />
    <callout
      ref="callout"
      :controlled="true"
      class="w-100 mt-3"
      :has-border="false"
      :has-toggle="hasCallout(item)"
      v-for="(item, index) in items"
      :key="index"
      :opened="item.isOpen"
      @click:open="
        openDetails(
          index,
          item.amendFiles,
          amendReportContainerPanelEnum.AMENDEDLIST,
          reportFileType
        )
      "
    >
      <div class="row" :class="{'margin-callout': !hasCallout(item)}">
        <div class="col-md-2 border-right custom-version-title-container">
          <p
            class="data-content mt-4 text-center font-weight-bold version-title-mobile"
          >
            Versión {{ item.fileRevision }}
          </p>
        </div>
        <div class="col-md-2">
          <label class="data-label mt-2 mb-0">Tipo de Archivo:</label>
          <p class="data-content mt-0">{{ item.fileSpecification.name }}</p>
        </div>
        <div class="col-md-2">
          <label class="data-label mt-2 mb-0">Fecha:</label>
          <p class="data-content mt-0">{{ item.date | date }}</p>
        </div>
        <div class="col-md-2">
          <template v-if="item.amendReason">
            <label class="data-label mt-2 mb-0">Razón de Enmienda:</label>
            <p class="data-content mt-0">{{ item.amendReason }}</p>
          </template>
        </div>
        <div class="col-md-4">
          <p class="text-right">
            <action-button
              variant="outline-success mt-3 mr-3 mobile-button-50 "
              i="fa fa-print font-18"
              class-icon="mx-0 no-margin"
              @click="onDownloadFile(item.id)"
            />
            <action-button
              variant="outline-success mt-3 mr-3  mobile-button-50"
              v-if="allowToSubmit && !(item.selectedOption == amendReportContainerPanelEnum.AMEND && item.isOpen)"
              i="fa fa-files-medical font-18"
              text="Enmendar"
              class-icon="mx-0 no-margin"            
              @click="
                openDetails(
                  index,
                  item.amendFiles,
                  amendReportContainerPanelEnum.AMEND,
                  reportFileType
                )
              "
            />
          </p>
        </div>
      </div>
      <template #edition>
        <amended-report-row 
          v-if="item.selectedOption == amendReportContainerPanelEnum.AMENDEDLIST" 
          :items="item.amendFiles"  
            @on-download="onDownloadFile($event)"                   
          />
        <amend-report
          @on-cancel-amend="
            openDetails(
              index,
              item.amendFiles,
              amendReportContainerPanelEnum.AMEND,
              reportFileType
            )
          "
          @on-create-amend="onCreateAmendHandler($event, item)"
          :item="item"
          v-if="item.selectedOption == amendReportContainerPanelEnum.AMEND"
        />
      </template>
    </callout>
  </div>
</template>

<script>
import SectionTitle from "SectionTitle";
import Callout from "custom-callout";
import ActionButton from "ActionButton";
import AmendReport from "./AmendReport.vue";
import AmendedReportRow from "./AmendedReportRow.vue"
import amendReportContainerPanel from "@/utils/constants/amendReportContainerPanel.js";

export default {
  name: "FileDetails",
  components: {
    Callout,
    ActionButton,
    AmendReport,
    SectionTitle,
    AmendedReportRow
  },
  props: {
    allowToSubmit: {
      type: Boolean,
      default: () => false,
    },
    items: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: null,
    },
    reportFileType: {
      type: String,
      default: null,
    },
  },
  computed: {
    amendReportContainerPanelEnum() {
      return amendReportContainerPanel;
    },
    hasCallout()
    {
      return (item)=> 
        item.amendFiles.length > 0
    }
  },
  methods: {
    openDetails(index, item, option, reportType) {
      this.$emit("on-open-details", index, item, option, reportType);
    },
    async onCreateAmendHandler(amendReason, item) {
      const result = await this.ShowCancelModal(
        "Atención",
        `¿Está seguro que desea enmendar el informe de ${item.fileType.name}?`,
        "Sí",
        "No"
      );
      if (result) {
        this.$emit("on-amend-file", {
          amendReason,
          fileTypeId: item.fileType.id,
          fileSpecificationId: item.fileSpecification.id
        });
      }
    },
    onDownloadFile(id) {
      this.$emit("on-download-file", id);
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/variables/_colors.scss";
@media (max-width: 425px) {
  .mobile-button-50 {
    width: 48% !important;
    margin: 2px !important;
  }
  .version-title-mobile {
    text-align: left !important;
    border-bottom: 1px solid map-get($colors, "secondary-5");
    padding-bottom: 15px;
  }

  .custom-version-title-container {
    border-right: none !important;
  }  
}
.margin-callout{
    margin-left: 0.4rem;
  }
</style>
